/**
 * Marca Zentera. Enquanto a logo oficial não for adicionada em /public/brand
 * (ver public/brand/README.md), exibe símbolo provisório + nome em texto.
 */
const PROVISIONAL = true;

export function Logo({ height = 20 }: { height?: number }) {
  if (!PROVISIONAL) {
    return <img src="/brand/zentera-logo.svg" alt="Zentera Virtual" style={{ height, width: 'auto' }} />;
  }
  return (
    <span className="inline-flex items-center gap-2" aria-label="Zentera Virtual">
      <img src="/brand/zentera-mark.svg" alt="" style={{ height, width: height }} />
      <span className="text-[14px] font-semibold tracking-[-0.01em] text-fg">Zentera</span>
    </span>
  );
}
